<template>
  <div class="text-static-default-mid body-1 flex md:justify-center">
    <div class="md:max-w-[700px] md:text-center">
      {{ i18n(translations.pageDescription) }}
    </div>
  </div>

  <h3 class="text-static-default-hi heading-3 mb-16 mt-32">
    {{ i18n(translations.eligibleDevices) }}
  </h3>

  <div class="space-y-16">
    <EligibleInsuranceCard
      v-for="eligibleInsurance in eligibleInsurances"
      :key="eligibleInsurance.orderlineId"
      class="w-full"
      :eligible-insurance
      :tracking-zone="TRACKING_ZONES.ELIGIBLE_INSURANCES"
    />
  </div>

  <div v-if="features.repair.enabled" class="mt-32 space-y-16">
    <h3 class="heading-3 w-full">{{ i18n(translations.repairTitle) }}</h3>
    <RepairCard :tracking-zone="TRACKING_ZONES.ELIGIBLE_INSURANCES" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import EligibleInsuranceCard from '../../components/EligibleInsuranceCard/EligibleInsuranceCard.vue'
import RepairCard from '../../components/RepairCard/RepairCard.vue'
import { TRACKING_ZONES } from '../../constant'
import type { EligibleInsurance } from '../../types'

import translations from './EligibleInsurances.translations'

const i18n = useI18n()
const { features } = useMarketplace()

defineProps<{
  eligibleInsurances: EligibleInsurance[]
}>()
</script>
